import { BusinessActionTypes, ServicePackageConstant, ServicePackage } from './business.types';
import { DirectDepositStatus, CreditCardStatus, BusinessState } from './business.types';

export const REGISTER_OR_UPDATE_BUSINESS: BusinessActionTypes = 'REGISTER_OR_UPDATE_BUSINESS';
export const GET_BUSINESS: BusinessActionTypes = 'GET_BUSINESS';
export const VALIDATE_PHONE: BusinessActionTypes = 'VALIDATE_PHONE';
export const GET_STATEMENTS: BusinessActionTypes = 'GET_STATEMENTS';

export const BUSINESS_CATEGORIES_FIELD_LABEL = 'Business Category';
export const SERVICE_PACKAGE_FIELD_LABEL = 'Service Package';

export const GENERAL_BUSINESS_CATEGORY = 'GENERAL';
export const MARTIALART_BUSINESS_CATEGORY = 'MARTIALART';

export const M3PLUS: ServicePackage = 'M3PLUS';
export const M3: ServicePackage = 'M3';
export const M3BASIC: ServicePackage = 'M3BASIC';

export const LOGO_HERE: string = require('../img/M3_Logo02_FOR-WEB.jpg');

export const businessCategories = [
  {
    name: 'General',
    value: GENERAL_BUSINESS_CATEGORY
  },
  {
    name: 'Martial Arts',
    value: MARTIALART_BUSINESS_CATEGORY
  }
];

export const servicePackages: Array<ServicePackageConstant> = [
  {
    name: 'M3 Plus',
    value: M3PLUS
  },
  {
    name: M3,
    value: M3
  },
  {
    name: 'M3 Basic',
    value: M3BASIC
  }
];

export const DIRECT_DEPOSIT_UPDATE: DirectDepositStatus = 'UPDATED';
export const DIRECT_DEPOSIT_CREATED: DirectDepositStatus = 'CREATED';
export const DIRECT_DEPOSIT_REMAINED: DirectDepositStatus = 'REMAINED';
export const CREDIT_CARD_UPDATE: CreditCardStatus = 'UPDATED';
export const CREDIT_CARD_CREATED: CreditCardStatus = 'CREATED';
export const CREDIT_CARD_REMAINED: CreditCardStatus = 'REMAINED';

export const CREDIT_CARD_MONTHS = [
  '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', 
];

export const generateCreditCardYears = (): Array<string> => {
  const thisYear = new Date().getFullYear();
  const nextSevenYears = [
    thisYear, thisYear + 1, thisYear + 2, thisYear + 3, thisYear + 4, thisYear + 5, thisYear + 6
  ];

  return nextSevenYears.map((year: number) => year.toString().slice(2));
};

export const initialBusinessState: BusinessState = {
  statusCode: 0,
  business: undefined,
  validation: {},
  statements: []
};



// WEBPACK FOOTER //
// ./src/business/business.constants.tsx